const DEFAULT_ASU_HOST = 'https://sites.thecollege.asu.edu';
const LOCAL_DEV_ASU_HOST = 'http://fac22.asu.ddev.site';

const parseBooleanString = (value) => {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return null;
};

const shouldUseLocalDrupalHost = () => {
  const envFlag = parseBooleanString(process.env.REACT_APP_USE_LOCAL_DRUPAL_HOST);
  if (envFlag !== null) return envFlag;

  if (typeof window !== 'undefined') {
    try {
      const flag = parseBooleanString(
        window.localStorage?.getItem('clas:useLocalDrupalHost')
      );
      if (flag !== null) return flag;
    } catch (_error) {
      // ignore storage errors
    }

    const hostname = window.location.hostname.toLowerCase();
    if (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname.endsWith('.local')
    ) {
      return true;
    }
  }
  return false;
};

const resolveAsuHost = () => {
  return shouldUseLocalDrupalHost() ? LOCAL_DEV_ASU_HOST : DEFAULT_ASU_HOST;
};

export {
  DEFAULT_ASU_HOST,
  LOCAL_DEV_ASU_HOST,
  resolveAsuHost,
  shouldUseLocalDrupalHost
};
